import { __decorate } from 'tslib';
import { unsafeCSS, css, LitElement, html } from 'lit';
import { property, query, customElement } from 'lit/decorators.js';
import clsx from 'clsx';
import css_248z from './switchButton.styles.css.js';

/**
 * Switch Button Component.
 *
 * @element ht-switch-button
 * @slot left - Slot para contenido alineado a la izquierda.
 * @slot right - Slot para contenido alineado a la derecha.
 * @fires toggle - Se dispara cuando el botón cambia de estado.
 */
let HTSwitchButton = class HTSwitchButton extends LitElement {
    constructor() {
        super(...arguments);
        this.isPressed = false;
        this.text = '';
        this._hasLeft = false;
        this._hasRight = false;
    }
    togglePressed() {
        this.isPressed = !this.isPressed;
        this.dispatchEvent(new CustomEvent('toggle', {
            detail: { isPressed: this.isPressed },
        }));
    }
    _handleSlotLeftChange({ target }) {
        var _a;
        const hasLeft = target.assignedNodes().length > 0;
        this._hasLeft = hasLeft;
        (_a = this.leftWrapper) === null || _a === void 0 ? void 0 : _a.toggleAttribute('hidden', !hasLeft);
    }
    _handleSlotRightChange({ target }) {
        var _a;
        const hasRight = target.assignedNodes().length > 0;
        this._hasRight = hasRight;
        (_a = this.rightWrapper) === null || _a === void 0 ? void 0 : _a.toggleAttribute('hidden', !hasRight);
    }
    get getButtonClasses() {
        return clsx('switchButton', { 'switchButton--active': this.isPressed });
    }
    get getContainerClasses() {
        return clsx('switchButton__container', {
            'switchButton__container--active': this.isPressed,
            'switchButton__container--textless': !this.text,
        });
    }
    get getTextClasses() {
        return clsx('subtitle2', 'switchButton__text', {
            'switchButton__text--active': this.isPressed,
        });
    }
    render() {
        return html `
      <button class="${this.getButtonClasses}" @click="${this.togglePressed}">
        <div class="${this.getContainerClasses}">
          <slot
            id="left-wrapper"
            name="left"
            @slotchange=${this._handleSlotLeftChange}
            hidden
          ></slot>
          ${this.text
            ? html `<p class="${this.getTextClasses}">${this.text}</p>`
            : ''}
          <slot
            id="right-wrapper"
            name="right"
            @slotchange=${this._handleSlotRightChange}
            hidden
          ></slot>
        </div>
      </button>
    `;
    }
};
HTSwitchButton.styles = css `
    ${unsafeCSS(css_248z)}
  `;
__decorate([
    property({ type: Boolean, attribute: 'is-pressed' })
], HTSwitchButton.prototype, "isPressed", void 0);
__decorate([
    property({ type: String })
], HTSwitchButton.prototype, "text", void 0);
__decorate([
    query('#left-wrapper')
], HTSwitchButton.prototype, "leftWrapper", void 0);
__decorate([
    query('#right-wrapper')
], HTSwitchButton.prototype, "rightWrapper", void 0);
HTSwitchButton = __decorate([
    customElement('ht-switch-button')
], HTSwitchButton);
var HTSwitchButton$1 = HTSwitchButton;

export { HTSwitchButton$1 as default };
//# sourceMappingURL=switchButton.js.map
